'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';

class ItemTemplateController extends FormController {
    /* @ngInject */
    constructor(
        ItemTemplatesService,
        $scope,
        $mdToast
    ) {
        let itemTemplate = $scope.$parent.$resolve.itemTemplate;
        super(
            itemTemplate,
            'Modelo de item',
            ItemTemplatesService
        );

        Object.assign(this, {
            ItemTemplatesService,
            $mdToast
        });
        this.btnEnabled = true;
    }

    $onInit() {
        super.$onInit();
        this.isDeleted = !!this.model.deletedAt;
    }

    hide() {
        this.showHideSpin = true;
        this.ItemTemplatesService.Model.hide({
            id: this.model.id
        }).$promise.then(() => {
            this.showHideSpin = false;
            this.model.deletedAt = new Date();
            this.simpleSuccess('Item archivado correctamente');
        });
    }

    unhide() {
        this.showHideSpin = true;
        this.ItemTemplatesService.Model.unhide({
            id: this.model.id
        }).$promise.then(() => {
            this.showHideSpin = false;
            this.model.deletedAt = null;
            this.simpleSuccess('Item desarchivado correctamente');
        });
    }
}

export default ItemTemplateController;
